import { FormField } from '@/components/UI/FormFields';
import { getRegisterConfig } from '@/components/UI/FormFields/FormField.utils';
import { AutoFill, KeyboardEventHandler } from 'react';
//@ts-expect-error - old hook form - replace with `react-hook-form@latest`
import { useFormContext } from 'react-hook-form';
import { MetaDataType } from '@/model/Metadata.model';
import '@/components/Metadata/Fieldtypes/MetadataFields.scss';

interface TextProps {
  value?: string;
  name: string;
  label: string;
  disabled?: boolean;
  hint?: string;
  required?: boolean;
  pattern?: { value: RegExp; message: string };
  placeholder?: string;
  maxLength?: number;
  autoFocus?: boolean;
  testId?: string;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  metadataType?: MetaDataType;
  autoComplete?: AutoFill;
}

const Text: React.FC<TextProps> = ({
  value,
  name,
  label,
  disabled = false,
  hint,
  required,
  pattern,
  placeholder,
  maxLength,
  autoFocus,
  onKeyDown,
  testId = 'text-field',
  autoComplete = 'off',
  metadataType,
}) => {
  const { register, errors } = useFormContext();
  return (
    <FormField label={label} name={name} hint={hint} required={required} testPrefix={testId}>
      <div className={metadataType === 'study_meta' ? 'metadata-text-container' : ''}>
        <input
          type="text"
          data-test-component="Text"
          data-test-element="input"
          style={{ marginBottom: 0 }}
          className={errors?.[name] ? 'input__error' : ''}
          name={name}
          defaultValue={value}
          autoComplete={autoComplete}
          ref={register(getRegisterConfig({ required, pattern, maxLength: maxLength ?? 250 }))}
          disabled={disabled}
          placeholder={placeholder}
          autoFocus={autoFocus}
          data-testid={testId}
          onKeyDown={onKeyDown}
        />
      </div>
    </FormField>
  );
};

export default Text;
